import { render, staticRenderFns } from "./costSame.vue?vue&type=template&id=7aff0923&scoped=true"
import script from "./costSame.vue?vue&type=script&lang=js"
export * from "./costSame.vue?vue&type=script&lang=js"
import style0 from "./costSame.vue?vue&type=style&index=0&id=7aff0923&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aff0923",
  null
  
)

export default component.exports